var _path, _path2, _path3, _g, _use, _use2, _use3, _use4;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgGw(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "flag-icons-gw",
    viewBox: "0 0 640 480",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ce1126",
    d: "M0 0h220v480H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcd116",
    d: "M220 0h420v240H220z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#009e49",
    d: "M220 240h420v240H220z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "gw-b",
    transform: "matrix(80 0 0 80 110 240)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "gw-a",
    fill: "#000001",
    d: "M0-1v1h.5",
    transform: "rotate(18 0 -1)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gw-a",
    width: "100%",
    height: "100%",
    transform: "scale(-1 1)"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gw-b",
    width: "100%",
    height: "100%",
    transform: "rotate(72 110 240)"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gw-b",
    width: "100%",
    height: "100%",
    transform: "rotate(144 110 240)"
  })), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gw-b",
    width: "100%",
    height: "100%",
    transform: "rotate(-144 110 240)"
  })), _use4 || (_use4 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gw-b",
    width: "100%",
    height: "100%",
    transform: "rotate(-72 110 240)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGw);
export default __webpack_public_path__ + "static/media/gw.3b1eba4bfbd859d523f4f9bba24a814a.svg";
export { ForwardRef as ReactComponent };